(function ($, window, document) {
	var $win         = $(window);
	var $doc         = $(document);
	var isLoading    = false;
	var headerHeight = $('.header').outerHeight();
	var lastScrollTop = window.pageYOffset || document.scrollTop;
	var scrollDirection = 'down';
	var scrollMagicNumber1 = 142;
	var scrollMagicNumber2 = 156;
	var scrollMagicFactor  = 1225; // lock and scroll boxes initially calibratred to this screen height
	var scrollMagicImageHeightBase = 500; // base height of lock and scroll image when full desktop

	function window_width() {
		var myWidth = 0;
		if (typeof window.innerWidth == "number") myWidth = window.innerWidth;
		else if (document.documentElement && document.documentElement.clientWidth)
			myWidth = document.documentElement.clientWidth;
		else if (document.body && document.body.clientWidth)
			myWidth = document.body.clientWidth;
		return myWidth;
	}

	function window_height() {
		var myHeight = 0;
		if (typeof window.innerHeight == "number") myHeight = window.innerHeight;
		else if (document.documentElement && document.documentElement.clientHeight)
			myHeight = document.documentElement.clientHeight;
		else if (document.body && document.body.clientHeight)
			myHeight = document.body.clientHeight;
		return myHeight;
	}
	$(document).on("dragstart", function(e) {
		if (e.target.nodeName.toUpperCase() == "IMG" || e.target.nodeName.toUpperCase() == "A") {
			return false;
		}
   });
	$(document).ready(function() {
		$("input").on('propertychange input', function () {
			const inputVal = $(this).val();

			if (inputVal != '') {
				$(this).closest('.gfield').addClass('field-active');
				$(this).closest('.form__row').addClass('field-active')
			} else {
				$(this).closest('.form__row').removeClass('field-active')
				$(this).closest('.gfield').removeClass('field-active');
			}

		})
	});

	function detectScrollDirection() {
		var st = window.pageYOffset || document.documentElement.scrollTop;
		if (st > lastScrollTop) scrollDirection = 'down';
		else scrollDirection = 'up';
		lastScrollTop = st <= 0 ? 0 : st; // for mobile or negative scrolling
	}

	$(window).load(function() {
		$("input[type=password]").val('');
	});

	$('.next-btn').on('click', function (e) {
		e.preventDefault();

		const $this = $(this);
		const $section = $this.closest('section');
		const $slider = $section.find('.slider--cards');
		const $slickNext = $slider.find('.slick-next');
		const $prevButton = $this.siblings('.prev-btn');
		$prevButton.addClass('visible');
		$slickNext.trigger('click');
	});
	$('.prev-btn').on('click', function (e) {
		const $this = $(this);
		const $section = $this.closest('section');
		const $slider = $section.find('.slider--cards');
		const $slickPrev = $slider.find('.slick-prev');
		$slickPrev.trigger('click');
		return false;
	})

	$('.js-tab-link').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);
		const target = $this.attr('href');

		const links = $this.parents('.section__actions').find('.js-tab-link');
		$('.slick-slider').slick('slickGoTo', 0);

		links.each(function (index, el) {
			const href = $(this).attr('href');
			$(this).parent().removeClass('is-active');
			$(href).removeClass('is-active')
			$(href).removeClass('is-fade');
		})

		setTimeout(() => {
			$(target).addClass('is-fade');
			initSliderBoxes();
		}, "500")

		$(target).addClass('is-active');
		$this.parent().addClass('is-active');
	})

	$('.js-tooltip-close').on('click', function () {
		$(this).parents('.tooltip__content').prev('.tooltip__link').trigger('click');
		$(this).parents('.tab').find('.tab__image').removeClass('is-active');
		return false;
	});

	function initSliderBoxes() {
		if ($('.slider--floorplans.js-slider-boxes').length) {
			$('.slider--floorplans.js-slider-boxes .slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrow: true,
			});
		}
	}

	function initSliders() {
		if ($('.js-slider-hero').length) {
			$('.js-slider-hero .slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				autoplay: true,
				fade: true,
				dots: true,
			});
		}

		if ($('.js-slider').length) {
			$('.js-slider .slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				arrow: true,

				responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 1,
					}
				},
			  ]
			});
		}

		if ($('.js-slider-boxes').not('.slider--floorplans').length) {
			$('.js-slider-boxes').not('.slider--floorplans').find('.slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrow: true,
			});
		}

		if ($('.js-slider-galery').length) {
			$('.js-slider-galery .slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrow: true,
				draggable: false,
				responsive: [
					{
						breakpoint: 768,
						settings: {
							draggable: true,
						}
					}
				]
			});
		}

		if ($('.js-slider-mobile').length) {
			jsSliderMobile();
		}

		if ($('.js-slider-tabs').length) {
			$('.js-slider-tabs .slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: false,
				speed: 500,
				fade: false,
				autoplay: false,
			});

		}

		if ($('.js-slider-tabs-secondary').length) {

			$('.js-slider-tabs-secondary .slider__slides').each(function(index){

				let $theSlider = $(this);
				let uniqueID = $(this).attr('sliderid');
				
				$theSlider.not('.slick-initialized').slick({
					infinite: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: true,
					speed: 500,
					fade: false,
					draggable: false,
					prevArrow: '.slider__prev-tabs.'+uniqueID,
					nextArrow: '.slider__next-tabs.'+uniqueID,
				});

			});
/**
 * 
 * 			$('.js-slider-tabs-secondary .slider__slides').not('.slick-initialized').slick({
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				arrows: true,
				speed: 500,
				fade: false,
				draggable: false,
				prevArrow: '.slider__prev-tabs',
				nextArrow: '.slider__next-tabs',
				appendArrows: $sliderControls
			});
 * 
 */
			setTimeout(function () {
				repositionInclusionsTooltips();
			}, 500);
		}
	}

	function jsSliderMobile() {
		$('.js-slider-mobile').not('.slick-initialized').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrow: true,
			mobileFirst: true,
			responsive: [
				{
					breakpoint: 768,
					settings: 'unslick'
				}
			]
		})
	}

	$('.field--checkbox .gfield_label').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);
		$this.parent().toggleClass('is-active');

		$this.closest('.field--checkbox')
			 .siblings()
			 .removeClass('is-active');

		$this.next()
			.stop(true, true)
			.slideToggle()

		$this.closest('.field--checkbox')
			 .siblings()
			 .find('.ginput_container_checkbox')
			 .slideUp();
	})

	$('.js-toggle-filter').on('click', function (e) {
		e.preventDefault();
		const $this = $(this)

		if ($win.width() <= 767) {
			$('body').toggleClass('filter-is-active');

			$('.filters').toggleClass('is-active');

		} else {
			$this.toggleClass('is-active');
			$this.closest('section').toggleClass('filter-visible');
			$('.slick-slider').slick('slickGoTo', 0);

			if (!$this.hasClass('is-active')) {
				$this.find('span').text('Open filter')
			} else {
				$this.find('span').text('Close filter')
			}
		}
	})

	$('.slider__next').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);
		const $nextArrow = $this.closest('section').find('.slick-next')

		$($nextArrow).trigger('click')
	});

	$('.js-toggle-popup, a[href=#enquire], a[href=#book-an-appointment], a.flyer_download').on('click', function (e) {
		e.preventDefault();
		const $header = $('.header');
		if ($(this).hasClass('flyer_download') && !$(this).hasClass('has_submitted')) {
			$('.popup-flyer').addClass('is-active');
			$('body').addClass('is-not-scrollable');
			if($(this).hasClass('archive')){ // sets the src of the download popup flyer - allows for multiple on a page
				$('body').attr("data-download-popup", $(this).data('file'));
			}

		}
		else if ($(this).hasClass('flyer_download') && $(this).hasClass('has_submitted')) {
			window.open($(this).attr('data-file'));
			return true;
		}
		else if ($(this).attr('href') == '#book-an-appointment') {
			$('.popup-book-an-appointment').addClass('is-active');
			$('body').addClass('is-not-scrollable');
			if ($(this).parents('section').hasClass('module--display-homes')) {
				let $thisCardHref = $(this).parents('.card').find('.card__href');
				if ($thisCardHref.length > 0) {
					var thisHref = $($thisCardHref).attr('href');
					$('#input_12_12').val(thisHref);
				}
			}
		}
		else if ($(this).attr('href') == '#enquire') {
			$('.popup-enquire').addClass('is-active')
			$('body').addClass('is-not-scrollable');
		}
		else {
			$('body').removeAttr("data-download-popup");
			$('.popup-enquire, .popup-book-an-appointment, .popup-flyer').removeClass('is-active');
			$('body').removeClass('is-not-scrollable');
		}

		if ($header.hasClass('is-visible')) {
			const $top = $('.header.is-visible').outerHeight();
			$('.popup-enquire, .popup-book-an-appointment').css('top', $top)
		} else {
			const $top = $('.header').outerHeight();
			const $paddingBottom = parseInt($('.header').css('padding-bottom'));
			$('.popup-enquire, .popup-book-an-appointment').css('top', $top - $paddingBottom + 10)
		}
	});

	$('.menu-item-has-children > a').on('click', function (e) {
		if ($win.width() <= 1399) {
			if ($(this).hasClass('js-mobile-nav-tap')) {
				e.preventDefault();
				const $this = $(this);
				$this.closest('li')
					.find('.sub-menu')
					.toggleClass('is-active')
			}
			else return true;
		}
		else return true;
	});
	$('li.menu-item > a').on('click', function (e) {
		const $thisNav = $(this);
		const thisNavHref = $thisNav.attr('href');
		const hashPos = thisNavHref.indexOf('#');
		if (hashPos != -1) {
			// check to see if the anchor exists
			const anchor = thisNavHref.substring(hashPos);
			if ($(anchor).length > 0) {
				// smooth scroll to this place
				$('html, body').animate({
					scrollTop: $(anchor).offset().top
				}, 800);
				return false;
			}
			else return true;
		}
		else return true;
	})

	$('.close-dropdown').on('click', function (e) {
		if ($win.width() <= 1399) {
			e.preventDefault();
			const $this = $(this);
			$this.closest('.sub-menu')
				 .toggleClass('is-active')
		}
	})

	$('.js-preferences-form').on('submit', function(event){
		event.preventDefault();
		var url = $('.js-page-select option:selected').val();
		window.location.href = url;
	})

	function fadeAnimation() {
		const $elementToFade = $('.fade-out');
		const $pageTop = $(window).scrollTop();
		const $windowHeight = window_height();
		const $windowBottom = $pageTop + $windowHeight;

		$('.fade-load').each(function () {
			if ($windowBottom >= $(this).offset().top) {
				$(this).addClass('is-animated')
			} else {
				$(this).removeClass('is-animated')
			}
		})
	}

	function visibleHeader() {
		const $header = $('.header');
		const $pageTop = $(window).scrollTop();
		const $headerHeight = $header.outerHeight();
		const $heroHeight = $('.hero').outerHeight();

		if ($pageTop >= $headerHeight - 20) {
			$('.header--scroll').addClass('is-visible');
		} else {
			$('.header--scroll').removeClass('is-visible');
		}
	}

	$('.tooltip__link').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);

		$this.parent()
			 .siblings()
			 .removeClass('is-active');

		$this.parent()
			 .toggleClass('is-active');

		$this.parents('.tab')
			 .find('.tab__image')
			 .toggleClass('is-active');
	})

	function toggleClass(el) {
		el.addClass('is-active')
			.siblings().removeClass('is-active')
	};

	$('.js-burger-btn').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);
		$('body').toggleClass('is-not-scrollable');
		const $windowWidth = $(window).width();

		const $burgerBtnText = $this.find('p');
		$this.toggleClass('is-active');
		$this.find('.burger-btn').toggleClass('is-active');
		const $header = $this.closest('.header');
		$header.toggleClass('nav-visible');
		const $menu = $header.find('.header__nav');
		$menu.toggleClass('is-active');

		if ($this.hasClass('is-active')) {
			$burgerBtnText.text('Close')
		} else {
			$burgerBtnText.text('Menu')
		}

		if ($windowWidth <= 767) {
			$('.header').toggleClass('mobile-nav-is-open')
		}
	});

	$doc.on('click', '.js-link-pagination', function (e) {
		e.preventDefault();

		const $this = $(this);
		$this.parent()
			 .toggleClass('is-active')
			 .find('.pagination__dropdown')
			 .slideToggle()
	})

	$doc.on('click', '.js-pagination a:not(.js-link-pagination)', function(e) {
		e.preventDefault();

		const url = $(this).attr('href');
		loadPosts(url);
	});

	$('.js-posts-filter').on('change', function(e) {
		e.preventDefault();

		const url = $(this).find('option:selected').val();
		loadPosts(url);
	})

	function loadPosts(url) {
		if (isLoading) {
			return;
		}

		let $ajaxContainer = $('.js-ajax-container');
		let $postsHolder   = $ajaxContainer.find('.js-posts-holder');
		let $pagination    = $ajaxContainer.find('.js-pagination');

		$.ajax({
			url: url,
			type: "GET",
			beforeSend: function(){
				isLoading = true;
				toggleSpinner();
		   },
		}).done( function(response){
			let $newAjaxContainer = $('.js-ajax-container', response);
			let $newPostsHolder   = $newAjaxContainer.find('.js-posts-holder');
			let $newPagination    = $newAjaxContainer.find('.js-pagination');

			let newPosts = $newPostsHolder.children();
			newPosts.css('display', 'none');

			$postsHolder.replaceWith( $newPostsHolder );
			newPosts.each(function(i){
				$(this).fadeIn(i*200);
			})

			$pagination.html($newPagination.html());
			fadeAnimation();

			isLoading = false;
			toggleSpinner();

			$('html, body').animate({
				scrollTop: $ajaxContainer.offset().top
			}, 600, 'linear');
		})
	}

	function toggleSpinner() {
		const $spinner = $('.loading-screen');
		$spinner.toggleClass('show');
	}
	$('.js-tabs').each(function(){
		$(this).on('click mouseover', '.tabs__nav li a', function (e) {
			e.preventDefault();
			const $this = $(this);
			const href = $this.attr('href');
			const $currentTab = $(href);

			$('.slider__slide .js-tabs li.is-active').removeClass('is-active'); // remove all active classes on all slides
			$('.slider__slide .tabs__body .tab.is-active').removeClass('is-active');
			toggleClass($this.parent())
			toggleClass($currentTab)
			let partialHref = href.substring(0,5);
			let hrefMinusHash = href.substring(1,5);

			$('.slider__slide .js-tabs li a[href^="'+partialHref+'"]').parent().addClass('is-active');
			$('.slider__slide .tabs__body div[id^="'+hrefMinusHash+'"]').addClass('is-active');

			if ($this.data('connector')) {
				// user clicked on a two tabs with checklists tab, try and find the corresponding hotspot module
				let thisConnector = $this.data('connector');
				let $locatedHotspotModule = $('.section-tabs.module--hotspot-module.toggle-hotspot-connector[data-connector="' + thisConnector + '"');
				if ($locatedHotspotModule.length > 0) {
					$('.section-tabs.module--hotspot-module.toggle-hotspot-connector.toggle-hotspot-connector--is-active').removeClass('toggle-hotspot-connector--is-active');
					$locatedHotspotModule.addClass('toggle-hotspot-connector--is-active');
					$locatedHotspotModule.find('.js-slider-tabs-secondary .slider__slides').each(function () {
						let $thisSlider = $(this);
						$thisSlider.slick('unslick');
						$thisSlider.slick({
							infinite: true,
							slidesToShow: 1,
							slidesToScroll: 1,
							arrows: true,
							speed: 500,
							fade: false,
							draggable: false,
							prevArrow: '.slider__prev-tabs',
							nextArrow: '.slider__next-tabs',
						});
						setTimeout(function () {
							repositionInclusionsTooltips();
						}, 500);
					});
				}
			}

			e.preventDefault();
		});
	});
	

	function initConnectedHotspots() {
		let $foundHotspots = $('.section-tabs.module--hotspot-module.toggle-hotspot-connector');
		$foundHotspots.removeClass('toggle-hotspot-connector--is-active');
		$foundHotspots.first().addClass('toggle-hotspot-connector--is-active');
	}

	$('.js-accordion .accordion__head').on('click', function (e) {
		const $this = $(this);

		$this.toggleClass('is-active');

		$this.parent()
			 .siblings()
			 .find('.accordion__head')
			 .removeClass('is-active');

		$this.next()
			.stop(true, true)
			.slideToggle()
			.parent()
				.toggleClass('is-active')
			.siblings()
			.removeClass('is-active')
			.find('.accordion__body').slideUp();

		e.preventDefault();
	});

	$('.js-toggle-select').on('click', function (e) {
		e.preventDefault();

		const $this = $(this);
		$this.parent().toggleClass('is-active');

		$this.closest('.form__row')
			 .siblings()
			 .find('.form__body-head')
			 .removeClass('is-active');

		$this.parent()
			.next()
			.stop(true, true)
			.slideToggle()

		$this.closest('.form__row')
			 .siblings()
			 .find('.list-checkboxes')
			 .slideUp();

	})

	$('.js-play-btn').on('click', function (e) {
		e.preventDefault();
		const $this = $(this);

		$this.toggleClass('is-playing')

		const $parent = $this.parent();
		const $video = $parent.find('video');

		if ($this.hasClass('is-playing')) {
			$video.trigger('play');
		} else {
			$video.trigger('pause');
		}
	})

	function initDropdowns() {
		$('.js-select select').selectric({
			disableOnMobile: false,
			nativeOnMobile: true,
			maxHeight: 310,

			onOpen: function() {
				const $this = $(this);
				$this.closest('.gfield').addClass('select-is-open');
				$this.closest('.form__col').addClass('select-is-open');

			},

			onClose: function() {
				const $this = $(this);
				$this.closest('.form__col').removeClass('select-is-open')
			},
		});

		$('.form-enquire select').selectric({
			disableOnMobile: false,
			nativeOnMobile: true,
			maxHeight: 310,

			onOpen: function() {
				const $this = $(this);
				$this.closest('.gfield').addClass('select-is-open')
			},

			onClose: function() {
				const $this = $(this);
				$this.closest('.gfield').removeClass('select-is-open')
			},

			onChange: function () {
				const $this = $(this);
				if ($this.val().length > 0) $this.parents('.gfield').addClass('field-active');
				else $this.parents('.gfield').removeClass('field-active');
			},
		});

		$('.form-filters-secondary select').selectric({
			disableOnMobile: false,
			nativeOnMobile: true,
			maxHeight: 310,

			onOpen: function() {
				const $this = $(this);
				$this.closest('.gfield').addClass('select-is-open')
			},

			onClose: function() {
				const $this = $(this);
				$this.closest('.gfield').removeClass('select-is-open')
			},
		});

		$('.js-select-mobile-native select').selectric({
		   disableOnMobile: false,
			nativeOnMobile: true,
			maxHeight: 310,

			onOpen: function() {
				const $this = $(this);
				$this.closest('.gfield').addClass('select-is-open');
			},

			onClose: function() {
				const $this = $(this);
				$this.closest('.gfield').removeClass('select-is-open');
			},

			onChange: function () {
				const $this = $(this);
				if ($this.val().length > 0) $this.parents('.gfield').addClass('field-active');
				else $this.parents('.gfield').removeClass('field-active');
			},
		});

		// nativeOnMobile means events via selectric are not available for mobile viewports
		// need to handle manually
		if ($win.width() <= 767) {
			$('.js-select-mobile-native select, .form-enquire select').on('change', function () {
				const $this = $(this);
				if ($this.val().length > 0) $this.parents('.gfield').addClass('field-active');
				else $this.parents('.gfield').removeClass('field-active');
			});
		}
	}

	function stickyBand(test) {
		const $sections = $('.js-scroll-to');
		const $pageTop = $(window).scrollTop();
		var controller = new ScrollMagic.Controller();
		const subNavLinks = $('.js-scroll-link');
		const $headerHeight = $('.header').outerHeight();
		const $headerSecondaryHeight = $('.header--scroll').outerHeight();
		const $heroHeigth = $('.hero').outerHeight();
		const $fixedBand = $('.js-fixed-band');
		const $fixedBandHeight = $fixedBand.outerHeight();

		if ($pageTop >= $headerHeight - 10) {
			$fixedBand.addClass('is-fixed');
		} else {
			$fixedBand.removeClass('is-fixed');
		}

		$sections.each(function (index, section) {
			const $section = $(section);
			const $sectionOffSetTop = $section.offset().top;
			const $sectionHeight = $section.outerHeight();

			if ($pageTop >= $sectionOffSetTop - $headerSecondaryHeight - $fixedBandHeight) {
				const $curreSectionId = '#' + $section.attr('id');
				const currentLink = $fixedBand.find(`[href='${$curreSectionId}']`);

				new ScrollMagic.Scene({
					triggerElement: $curreSectionId,
					duration: $($curreSectionId).outerHeight(),
				})
					.setClassToggle(currentLink, "is-active") // add class toggle
					.addTo(controller);

				$('.js-fixed-band').find('.js-scroll-link')
								   .parent()
								   .removeClass('is-active')

				$('.js-fixed-band').find('.js-scroll-link')
								   .removeClass('is-active')

				currentLink.addClass('is-active');

			}
		})
	}

	var $fixedBandHeight = 0;

	if ($('.js-sticky').length) {
		const $fixedBandOffsetTop = $('.js-fixed-band').offset().top;
		var $fixedBandHeight = $('.js-fixed-band').outerHeight();
	}

	function stickyElement() {
		const $stickyEl = $('.js-sticky');
		const $fixedBand = $('.js-fixed-band');
		const $paddingTopElement = parseInt($stickyEl.css("padding-top"))

		$($stickyEl).css({
			"maxWidth": $stickyEl.parent().width()
		});

		const $this = $(this);
		const $sectionBody = $stickyEl.closest('.grid')
		const $parentSectionHeight = $sectionBody.outerHeight();
		const $parentSectionOffset = $sectionBody.offset().top;
		const $sectionNavHeight = $stickyEl.outerHeight();
		const $headerHeight = $('.header--scroll').outerHeight();
		const $sectionBodyOffsetTop = $sectionBody.offset().top;

		const scrollTo = $sectionBodyOffsetTop + $parentSectionHeight - ($stickyEl.outerHeight() + $headerHeight + $fixedBandHeight);

		if ($this.scrollTop() + $headerHeight + $fixedBandHeight + $paddingTopElement > $sectionBodyOffsetTop) {
			$stickyEl.addClass('is-fixed');
			$stickyEl.removeClass('is-absolute');
			$stickyEl.css({
				top: $headerHeight + $fixedBandHeight + $paddingTopElement,
			})
		} else {
			$stickyEl.removeClass('is-fixed');
			$stickyEl.removeClass('is-absolute');

			$stickyEl.css({
				top: 0,
			})
		}

		if ($this.scrollTop() >= scrollTo) {
			$stickyEl.addClass('is-absolute');
			$stickyEl.removeClass('is-fixed');
			$stickyEl.css({
				top: $parentSectionHeight + $headerHeight - $sectionNavHeight - 50,
			})
		}
	}

	function fixedBandMobile() {
		const $stickyEl = $('.js-sticky-mobile');
		const $headerHeight = $('.header--scroll').outerHeight();

		if ($win.scrollTop() >= $stickyEl.parent().offset().top - $headerHeight) {
			$stickyEl.addClass('is-fixed')
			$stickyEl.css({
				top: $headerHeight,
			})

		} else {
			$stickyEl.removeClass('is-fixed');

			$stickyEl.css({
				top: 0,
			})
		}

	}

	function fixedBoxes() {
		const $boxSections = $('.section-boxes');
		$boxSections.each(function () {
			let $box = $(this).find('.js-box');

			$box.each(function (index, box) {
				const $this = $(this);
				const $stickyBox = $this.find('.box__image');
				const $sectionBody = $stickyBox.closest('.container');
				var $stickyBoxTop = $this.offset().top;

				const $lastChild = $sectionBody.find('.js-box:last-child');
				const isStart = $stickyBoxTop - (($win.outerHeight() - $this.outerHeight()));
				const $lastChildImg = $lastChild.find('.box__image');
				const section = $this.closest('section');
				const sectionPaddingTop = parseInt(section.css('padding-top'));
				const sectionPaddingBottom = parseInt(section.css('padding-bottom'));

				const isEnd = $lastChild.offset().top + (($win.outerHeight() - $this.outerHeight()));
				const isEnd2 = section.offset().top + (section.outerHeight() - $this.outerHeight());

				let magicNumber1 = scrollMagicNumber1;
				let magicNumber2 = scrollMagicNumber2;
				if (($win.width() > 767)) {
					// not mobile view
					magicNumber1 = magicNumber1 + (($win.height() - scrollMagicFactor) / 2);
					magicNumber2 = magicNumber2 + (($win.height() - scrollMagicFactor) / 2);

					// check the height of the image to see if we need to apply a scaling factor to these magic numbers
					if ($stickyBox.outerHeight() < scrollMagicImageHeightBase) {
						imageRatio = $stickyBox.outerHeight() / scrollMagicImageHeightBase;
						magicNumber1 *= imageRatio;
						magicNumber2 *= imageRatio;
					}
				}

				if (!$this.hasClass('box--first')) magicNumber1 = -150;
				if (!$this.hasClass('box--last'))  magicNumber2 = 0;

				if ($win.scrollTop() > (isStart + sectionPaddingTop + magicNumber1)) {
					$this.addClass('is-visible');
					$this.removeClass('is-absolute');
					$this.removeClass('is-visible-start');
					$this.siblings().removeClass('is-visible');
				} else if ($win.scrollTop() < (isStart + sectionPaddingTop + magicNumber1)) {
					$this.removeClass('is-visible');
					$this.removeClass('is-absolute');
					if (index == 0) $this.addClass('is-visible-start');
				}

				if ($win.scrollTop() > isEnd2 - ($this.outerHeight() / 2) + sectionPaddingBottom - magicNumber2) {
					$this.removeClass('is-visible');
					if (index == ($box.length - 1)) $this.addClass('is-absolute');
				}
				$($stickyBox).css({
					"maxWidth": $stickyBox.parent().width()
				  });
			})
		})
	}

	function repositionInclusionsTooltips() {
		if ($('.module--hotspot-module, .post-module--hotspot-module').length > 0) {
			$('.module--hotspot-module, .post-module--hotspot-module').each(function () {
				let $this = $(this);
				let tabWidth = $this.find('.tabs__body').innerWidth();
				let tabHeight = $this.find('.tabs__body').innerHeight();
				$this.find('.tooltip__content.flip-to-left').removeClass('flip-to-left');
				$this.find('.tooltip__content.flip-to-top').removeClass('flip-to-top');

				if (window_width() > 767 && tabWidth > 0 && tabHeight > 0) {
					$this.find('.tab').each(function () {
						let $thisTab = $(this);
						$thisTab.find('.tooltip').each(function () {
							// check each tooltip's position
							let $thisTooltip = $(this).find('.tooltip__content');
							let thisTooltipTop = $(this).position().top + $thisTooltip.position().top;
							let thisTooltipLeft = $(this).position().left + $thisTooltip.position().left;
							let thisTooltipBottom = thisTooltipTop + $thisTooltip.innerHeight();
							let thisTooltipRight = thisTooltipLeft + $thisTooltip.innerWidth();
							if (thisTooltipRight > tabWidth * 0.9) $thisTooltip.addClass('flip-to-left');
							if (thisTooltipBottom > tabHeight * 0.9) $thisTooltip.addClass('flip-to-top');
						});
					});
				}
			});
		}
	}

	$(window).on('load resize scroll', function () {
		if ($win.width() <= 767 && $('.js-sticky-mobile').length) {
			fixedBandMobile();
		}
		if ($('.js-sticky').length) {
			const $fixedBandOffsetTop = $('.js-fixed-band').offset().top;
			const $fixedBandHeight = $('.js-fixed-band').outerHeight();
			stickyElement();
		}
	})

	$(window).on('load scroll', function (e) {
		detectScrollDirection();
		fadeAnimation();
		visibleHeader();
		fixedBoxes();
		const $boxSection = $('.section-boxes');

		$boxSection.each(function (index, el) {
			const $boxes = $(this).find('.js-box').length

			if ($boxes <= 1) {
				$(this).find('.js-box').removeClass('js-box')
			}
		})

		if ($('.js-fixed-band').length) {
			const $fixedBandOffsetTop = $('.js-fixed-band').offset().top;
			const $fixedBandHeight = $('.js-fixed-band').outerHeight();
			stickyBand();
		}

		if ($('.js-sticky').length) {
			const $fixedBandOffsetTop = $('.js-fixed-band').offset().top;
			const $fixedBandHeight = $('.js-fixed-band').outerHeight();
			stickyElement();
		}

	})

	initSliders();

	$(window).on('load', function (e) {
		e.preventDefault();

		initConnectedHotspots();

		if ($('#map').length) {
			startMaps();
		}
		setTimeout(function () {
			repositionInclusionsTooltips();
		}, 500);

		$(window).trigger('scroll');
	})

	$(".js-scroll-link").on("click", function (e) {
		e.preventDefault();

		const $this = $(this);
		const $target = $this.attr("href");
		const $headerHeight = $('.header--scroll').outerHeight()
		const $fixedBand = $('.js-fixed-band');
		const $fixedBandHeight = $fixedBand.outerHeight();

		$this.parent()
			 .addClass('is-active')

		$this.parent()
			 .siblings()
			 .removeClass('is-active')

		$this.parent()
			 .siblings()
			 .find('.js-scroll-link')
			 .removeClass('is-active')

		$("html, body").animate(
			{
				scrollTop: $($target).offset().top - $headerHeight - $fixedBandHeight + 50,
			},
			1000
		);
	});

	$(function () {
		$('.popup-modal').magnificPopup({
			fixedContentPos: true,
			closeOnBgClick: true,
			alignTop: false,
		});

		$(document).on('click', '.popup-modal-dismiss', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});

		$('.popup-youtube, .popup-vimeo').magnificPopup({
			type: 'iframe',
			mainClass: 'mfp-fade',
			removalDelay: 160,
			preloader: false,
			fixedContentPos: false
		});

		$('.popup-modal').on('click', function () {
			if ($(this).attr('href') == '#popup-sign-up') {
				let recaptchaSiteKey = $('.js-form-register').find('button[data-sitekey]').first().attr('data-sitekey');
				grecaptcha.ready(function () {
					grecaptcha.render('recaptcha-container', {
						sitekey: recaptchaSiteKey
					});
				});
			}
			// $.magnificPopup.close();

			// $(this).magnificPopup('open');
			// setTimeout(() => {
			// 	$('.slick-slider').slick('slickGoTo');
			// }, "50")
		});
	});

	$(document).ready(function() {
		$('.slider--hero .galery__media').magnificPopup({
			delegate: 'a',
			type: 'image',

			gallery: {
				enabled: true,
				navigateByImgClick: true,
				preload: [0,1] // Will preload 0 - before current, and 1 after the current image
			},
		});
	});

	// Load AJAX data
	function loadAjax(filePath) {
		return $.ajax({
			'async': false,
			'global': false,
			'url': filePath
		}).responseJSON;
	}

	// Function to initialize maps
	function startMaps() {
		const mapDataAttr = $('.map').data('map');
		$('.map').each(function(){
			var $map = $(this);
			var map;
			var iBox;
			var $jsCards = $map.parents('.section__cols').find('.js-cards');

			// Use this data
			var mapData = $(this).data('map');
			// Use this data

			var mapData = {
				"mapOptions": {
					"center": {
						"lat": -37.9722326,
						"lng": 144.772275,
					},
					"zoom": 10,
					"minZoom": 5,
					"mapTypeControl": false,
					"styles": [
				{
					"featureType": "administrative",
					"elementType": "labels.text.fill",
					"stylers": [
								{
									"color": "#444444"
								}
							]
						},
						{
							"featureType": "landscape",
							"elementType": "all",
							"stylers": [
								{
									"color": "#f2f2f2"
								}
							]
						},
						{
							"featureType": "poi",
							"elementType": "all",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "road",
							"elementType": "all",
							"stylers": [
								{
									"saturation": -100
								},
								{
									"lightness": 45
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "all",
							"stylers": [
								{
									"visibility": "simplified"
								}
							]
						},
						{
							"featureType": "road.highway",
							"elementType": "geometry.fill",
							"stylers": [
								{
									"color": "#ffffff"
								}
							]
						},
						{
							"featureType": "road.arterial",
							"elementType": "labels.icon",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "transit",
							"elementType": "all",
							"stylers": [
								{
									"visibility": "off"
								}
							]
						},
						{
							"featureType": "water",
							"elementType": "all",
							"stylers": [
								{
									"color": "#dde6e8"
								},
								{
									"visibility": "on"
								}
							]
						}
					]
				}
			}
			if (!$(this).data('map').markers) {
				marker = new google.maps.Marker({
					position: mapData.position,
					map: map,
					content: content,
					iBoxOpen: false,
				});

				map = new google.maps.Map($map.get(0), mapData.mapOptions);
				return
			}

			let mapMarkers = $(this).data('map').markers;
			var markersLength = mapMarkers.length;

			if (mapMarkers) {
				var markers = [];
				var content;
				var markerCluster;
				var clusterIsEnabled = mapData.cluster;

				var clusterOptions = {
					styles: [{
						fontWeight: 'bold',
						fontFamily: 'Circular Std, sans-serif',
						textColor: 'white',
						height: 34,
						"url": main_theme.template_url + '/assets/dist/images/cluster-ico.svg',
						width: 34,
						textSize: 17,
					}]
				};

				map = new google.maps.Map($map.get(0), mapData.mapOptions);

				map.addListener('click', function(event) {
					iBox.close()

					for (var i = 0; i < markers.length; i++) {
						markers[i].iBoxOpen = false;
					}
				})


				map.addListener("idle", () => {
					checkVisibleMarkers();
				});

				function checkVisibleMarkers(){

					const bounds = map.getBounds();
					let visibleRegions = [];

					markers.filter(m => m.visible).forEach(m => {
					  let markerID = m.markerID;

					  if (bounds.contains(m.getPosition())) {
						$jsCards.find('#'+markerID).addClass('is-visible');
						if(m.region!=''){
							visibleRegions.push(m.region);
						}
					  } else {
						$jsCards.find('#'+markerID).removeClass('is-visible');
					  }

					});

					let visibleUnique = new Set(visibleRegions);
					visibleUnique = Array.from(visibleUnique);

					  // update map title with region(s)
					  if($('h3.section-map__heading span.js-heading')){
						if(visibleUnique.length <= 2 && visibleUnique.length > 1){
							visibleUniqueJoined = visibleUnique.join(', ');
							$('h3.section-map__heading span.js-heading').text(visibleUniqueJoined);
						} else if(visibleUnique.length === 1){
							$('h3.section-map__heading span.js-heading').text(visibleUnique[0]);
						} else {
							$('h3.section-map__heading span.js-heading').text('All Regions');
						}

					  }

				}


				$jsCards.empty()
				let array = [];
				const select = $('.selectric-scroll');
				const selectDropdown = select.find('ul');

				for (var i = 0; i < markersLength; i++) {
					if (mapMarkers[i].card !== undefined) {
						let priceString = '';
						if (typeof mapMarkers[i].card.price != 'undefined') {
							if (mapMarkers[i].card.price != null) {
								if (mapMarkers[i].card.price.length > 0) {
									let unformattedPrice = parseInt(mapMarkers[i].card.price);
									priceString = '<p>' + mapMarkers[i].card.paragraph + ' <span>$' + unformattedPrice.toLocaleString('en-AU') + '</span></p>';
								}
							}
						}

						cardContent = '<div id="' + mapMarkers[i].dataId
							+ '" class="card card--vertical" data-order="' + i + '"><a class="card--clickzone" href="'
							+ mapMarkers[i].card.href + '"></a><div class="grid"><div class="grid__col grid__col--size-7">'
							+ '<div class="card__image"><img src="' + mapMarkers[i].card.image + '"/></div></div>'
							+ '<div class="grid__col grid__col--size-8"><div class="card__body"><div class="card__content"><h5>'
							+ mapMarkers[i].card.title + '</h5><ul><li>' + mapMarkers[i].card.subtitle + '</li></ul>' + priceString
							+ '<a class="link" href="' + mapMarkers[i].card.href + '">' + mapMarkers[i].card.link
							+ '<img src="../wp-content/themes/soho/assets/src/images/ico-arrow-gold.svg" /></a></div>'
							+ '</div></div></div></div></div>';
					}
					else cardContent = '';
					content = '<div class="infobox"></div>';
					array.push(mapMarkers[i].region);

					$jsCards.append(cardContent)
					marker = new google.maps.Marker({
						position: mapMarkers[i].position,
						map: map,
						content: content,
						iBoxOpen: false,
						icon: mapMarkers[i].icon,
						markerID: mapMarkers[i].dataId,
						region: mapMarkers[i].region,
						suburb: mapMarkers[i].suburb,
					});

					iBox = new InfoBox();

					marker.addListener('click', function(){
						for (var i = 0; i < markers.length; i++) {
							markers[i].iBoxOpen = false;
						}

						if ($('.js-cards-scroll').length) {
							const $headerHeight = $('.header--scroll').outerHeight();

							$("html, body").animate(
								{
									scrollTop: $('.js-cards-scroll').offset().top - $headerHeight,
								},
								1000
							);
						}
						else if ($jsCards.length) {
							$jsCards.scrollTop(0);
						}

						if (this.iBoxOpen == false) {
							iBox.setContent(this.content);
							iBox.open(map, this);

							this.iBoxOpen = true;
						}
						$jsCards.addClass('is-visible');
						const target = '#' + this.markerID;
						$(target).addClass('is-active');
						$(target).siblings().removeClass('is-active');

						// client requested clicks of the map pins to push the newly active card tile to the top of the sidebar list
						// hold the active target in a temp variable
						var $tempTarget = $(target);
						$(target).remove();
						// sort the siblings
						var sortedSiblings = $jsCards.children('div').sort((a,b) => $(a).data('order') - $(b).data('order'));
						$jsCards.html(sortedSiblings).prepend($tempTarget);
					});
					markers.push(marker);
				}
				if (markers.length == 1) {
					// set the map center to the solitary marker that's on the map.
					map.setCenter(mapMarkers[0].position);
				}
				markerCluster = new MarkerClusterer(map, markers, clusterOptions);
				if ($map.parents('.module--houses-and-lands').length > 0) {
					google.maps.event.addListener(markerCluster, 'clusterclick', function(cluster) {
						let theseMarkers = cluster.getMarkers();
						let postIDs = [];
						let showSuburb = false;
						for (i in theseMarkers) {
							postIDs.push(theseMarkers[i].markerID);
							if (theseMarkers[i].suburb != undefined) {
								showSuburb = theseMarkers[i].suburb;
							}
						}

						if (postIDs.length > 0) {
							$.ajax({
								url: main_theme.ajax_url,
								type: 'POST',
								data: {
									action: 'populate_map_results_grid',
									postIDs: postIDs
								},
								success: function (html) {
									let heading = 'Displaying ' + postIDs.length + ' House and Land Packages';
									if (showSuburb != false) {
										heading += ' in ' + showSuburb;
									}
									$('#map-results-headline').html(heading);
									$('#map-results-grid').html(html.replace(/fade-load/g, '').replace(/fade-out/g, ''));
									$map.parents('.module--houses-and-lands').find('.js-map-results-holder').removeClass('hidden');
									$('html, body').animate({
										scrollTop: ($('#map-results-headline').offset().top - $('header').outerHeight())
									}, 800);
								}
							});
						}
					});
				}
			}
		});
	}

	$('.js-home-design-filters input').on('change', function() {
		var $filtersContainer = $(this).closest('.form-filters');
		var url = buildFilteringUrl($filtersContainer);
		loadPostsViews(url);
	})

	$('.js-townhome-region-filter').on('change', function() {
		if (isLoading) {
			return;
		}

		var url                    = $(this).find('option:selected').val();
		var $ajaxContainer         = $('.js-ajax-container');
		var $firstViewPostsHolder  = $ajaxContainer.find('.js-posts-view1-container');
		var $secondViewPostsHolder = $ajaxContainer.find('.js-posts-view2-container');

		$.ajax({
			url: url,
			type: "POST",
			beforeSend: function(){
				isLoading = true;
				toggleSpinner();
			},
		}).done(function(response){
			var $newAjaxContainer         = $('.js-ajax-container', response);
			var $newFirstViewPostsHolder  = $newAjaxContainer.find('.js-posts-view1-container');
			var $newSecondViewPostsHolder = $newAjaxContainer.find('.js-posts-view2-container');

			$firstViewPostsHolder.replaceWith($newFirstViewPostsHolder);
			$secondViewPostsHolder.replaceWith($newSecondViewPostsHolder);

			$('.js-ajax-container .js-posts-holder')
				.children()
				.addClass('is-animated');

			// initSliders();
			toggleSpinner();
			isLoading = false;
		})
	})

	$doc.on('click', '.js-clear-home-design-filters', function(e) {
		e.preventDefault();
		// reset all field options
		$('.filters form input:checked').prop('checked', false);

		const url = $(this).attr('href');
		loadPostsViews(url);
	});

	function buildFilteringUrl(container) {
		var data          = {};
		var url           = container.data('url');
		var checkedInputs = container.find('input:checked');

		if (! checkedInputs.length) {
			return url;
		}

		$.each(checkedInputs, function() {
			var inputName = $(this).attr('name');
			var inputValue = $(this).val();

			if (inputName in data) {
				data[inputName] = data[inputName] + ',' + inputValue;
			} else {
				data[inputName] = inputValue;
			}
		})

		$.each(data, function(key, value) {
			url = updateQueryStringParameter(url, key, value);
		})

		return url;
	}

	function loadPostsViews(url, append = false) {
		if (isLoading) {
			return;
		}

		var $ajaxContainer         = $('.js-ajax-container');
		var $firstViewPostsHolder  = $ajaxContainer.find('.js-posts-view1-container');
		var $secondViewPostsHolder = $ajaxContainer.find('.js-posts-view2-container');

		$.ajax({
			url: url,
			type: "POST",
			beforeSend: function(){
				isLoading = true;
				toggleSpinner();
			},
		}).done(function(response){
			var $newAjaxContainer         = $('.js-ajax-container', response);
			var $newFirstViewPostsHolder  = $newAjaxContainer.find('.js-posts-view1-container');
			var $newSecondViewPostsHolder = $newAjaxContainer.find('.js-posts-view2-container');

			if (append) {
				var newPosts = $newPostsHolder.children();

				$postsHolder.append(newPosts);
			} else {
				$firstViewPostsHolder.replaceWith($newFirstViewPostsHolder);
				$secondViewPostsHolder.replaceWith($newSecondViewPostsHolder);

				$('.js-ajax-container .js-posts-holder')
					.children()
					.addClass('is-animated');
			}

			initSliders()
			toggleSpinner();
			isLoading = false;
		})
	}

	$('.js-house-and-land-filters input').on('change', function() {
		const $filtersContainer = $(this).closest('.form-filters');
		const url = buildFilteringUrl($filtersContainer);

		loadHouseAndLands(url);
	})

	$doc.on('click', '.js-house-and-land-pagination a:not(.js-link-pagination)', function(e) {
		e.preventDefault();

		const url = $(this).attr('href');
		loadHouseAndLands(url);
	});

	$doc.on('click', '.js-clear-house-and-land-filters', function(e) {
		e.preventDefault();

		const url = $(this).attr('href');
		// clear all filters
		const $form = $(this).parents('form');
		$form.find('input:checked').each(function () {
			var $thisField = $(this);
			$thisField.prop('checked', false);
		});
		loadHouseAndLands(url);
	});

	function loadHouseAndLands(url) {
		if (isLoading) {
			return;
		}

		var $ajaxContainer    = $('.js-ajax-container');
		var $postsHolder      = $ajaxContainer.find('.js-posts-holder');
		var $mapResultsHolder = $ajaxContainer.find('.section-map-view');
		var $pagination       = $ajaxContainer.find('.js-house-and-land-pagination');

		$.ajax({
			url: url,
			type: "POST",
			beforeSend: function(){
				isLoading = true;
				toggleSpinner();
			},
		}).done(function(response){
			var $newAjaxContainer    = $('.js-ajax-container', response);
			var $newPostsHolder      = $newAjaxContainer.find('.js-posts-holder');
			var $newMapResultsHolder = $newAjaxContainer.find('.section-map-view');
			var $newPagination       = $newAjaxContainer.find('.js-house-and-land-pagination');

			$postsHolder.replaceWith($newPostsHolder);
			$mapResultsHolder.replaceWith($newMapResultsHolder);

			$('.js-ajax-container .js-posts-holder')
				.children()
				.addClass('is-animated');

			$pagination.replaceWith($newPagination);
			$('.js-house-and-land-pagination').addClass('is-animated');

			startMaps();

			toggleSpinner();
			isLoading = false;

			$('#map').addClass('is-animated');

			if ( $('.section--filters .section__actions').find('.is-active a').attr('href') == "#map-view" ) {
				$('.section-map-view').addClass('is-active');
			}

			$('html, body').animate({
				scrollTop: $ajaxContainer.offset().top - headerHeight
			}, 600, 'linear');
		})
	}

	function updateQueryStringParameter(uri, key, value) {
		const re = new RegExp("([?&])" + key + "=.*?(&|#|$)", "i");

		if (uri.match(re)) {
			let newUrl = uri.replace(re, '$1' + key + "=" + value + '$2');

			if (!value.length) {
				newUrl = newUrl.replace('?' + key + '=', '');
				newUrl = newUrl.replace('&' + key + '=', '');

				if (newUrl.indexOf('?') === -1) {
					newUrl = newUrl.replace('&', '?');
				}
			}

			return newUrl;
		} else {
			let hash = '';
			if (uri.indexOf('#') !== -1) {
				hash = uri.replace(/.*#/, '#');
				uri = uri.replace(/#.*/, '');
			}

			const separator = uri.indexOf('?') !== -1 ? "&" : "?";
			return uri + separator + key + "=" + value + hash;
		}
	}

	$win.on('load resize', function (e) {
		if ($('.js-cards').length) {
			if ($win.width() < 767) {
				setTimeout(() => {
					$('.js-cards').find('.card:first-child').addClass('is-active');
				}, "1000")
			}
		}
	});

	$win.on('resize', function (e) {
		if (!$('body').hasClass('tax-townhome_project')) {
			if ($('.slider--floorplans.js-slider-boxes').length) {
				$('.slider--floorplans.js-slider-boxes .slider__slides.slick-initialized').slick('unslick').slick('reinit');
				//console.log('resize');
			}
		}
		if ($('.js-slider-mobile').length > 0) {
			jsSliderMobile();
		}
		repositionInclusionsTooltips();
	});

	$doc.on('click', '.js-like a', function(event) {
		event.preventDefault();
		// console.log('like click');

		const $parent = $(this).parent();
		const postId  = $parent.data('id');
		const action  = $parent.hasClass('is-active') ? 'remove' : 'add';

		updateFavouritesList(postId, action);
	})

	function updateFavouritesList(postId, action) {
		isLoading = true;

		$('.js-like[data-id=' + postId + ']').toggleClass('is-active');

		const data = {
			'action' : 'efront_update_favourites',
			'type'   : action,
			'post_id': postId
		}

		$.post(main_theme.ajax_url, data, function(response){
			if (response.success) {
				updateLikeIconsVisibility(postId);
			}
			$('.favourites-count').html(response.count);
		})
	}

	function updateLikeIconsVisibility(postId) {
		$.ajax({
			url: main_theme.ajax_url,
			data: {
				action: 'efront_check_if_user_can_like_more',
				postId: postId
			},
			type: "GET",
			beforeSend: function(){
				isLoading = true
		   },
		}).done( function(response){
			if (! response.has_permissions) {
				$('.js-like:not(.is-active)').addClass('hidden');
			} else {
				$('.js-like').removeClass('hidden');
			}

			isLoading = false
		})
	}

	$doc.on( 'change', '.js-townhomes-projects-filters select', function(e) {
		if (isLoading) {
			return;
		}

		const $form               = $(this).closest('form');
		const $dropdownsContainer = $('.js-townhomes-projects-filters');
		const $estatesContainer   = $('.js-projects-ajax-container');
		let url                   = getUrlByFormData($form)

		const toggleView = $('.section-form .section__actions').find('.is-active .js-tab-link').attr('href').replace('#', '');

		$.ajax({
			url: url,
			type: "GET",
			data: {
				toggleView,
			},
			beforeSend: function(){
				isLoading = true;
				toggleSpinner();
			},
		}).done(function(response){
			let $newDropdownsContainer = $('.js-townhomes-projects-filters', response);
			let $newEstatesContainer = $('.js-projects-ajax-container', response);
			$dropdownsContainer.replaceWith($newDropdownsContainer);
			$estatesContainer.replaceWith($newEstatesContainer);

			let selectedRegion = $('#region').val();
			let selectedSuburb = $('#suburb').val();
			let $mapHeader = $('.section-map-view .section-map__heading');
			if (selectedRegion == '' && selectedSuburb == '') {
				$mapHeader.find('.js-heading').html('All Regions');
			}
			else if (selectedRegion != '' && selectedSuburb == '') {
				let selectedRegionLabel = $('#region option:selected').text();
				$mapHeader.find('.js-heading').html(selectedRegionLabel);
			}
			else if (selectedRegion == '' && selectedSuburb != '') {
				let selectedSuburbLabel = $('#suburb option:selected').text();
				$mapHeader.find('.js-heading').html(selectedSuburbLabel);
			}
			else {
				// both region and suburb is selected
				let selectedRegionLabel = $('#region option:selected').text();
				let selectedSuburbLabel = $('#suburb option:selected').text();
				$mapHeader.find('.js-heading').html(selectedRegionLabel + ', ' + selectedSuburbLabel);
			}

			$('.js-projects-ajax-container .section__head, .js-projects-ajax-container .cards')
				.addClass('is-animated');

			initDropdowns();
			toggleSpinner();
			startMaps();

			$('.js-projects-ajax-container .grid__col')
				.addClass('is-animated');
			isLoading = false

			$('#map').addClass('is-animated');
		})
	} )

	function getUrlByFormData($form) {
		let url      = $form.attr('action');
		let formData = {};

		// Get form data and group it.
		$.each($form.serializeArray(), function (index, fieldData) {
			let name = fieldData.name;

			if (fieldData.value == "" || fieldData.value == 'all') {
				return;
			}

			if (!(name in formData)) {
				formData[name] = [];
			}

			formData[name].push(fieldData.value);
		});

		$.each(formData, function (inputName, value) {
			value = value.toString();
			url   = updateQueryStringParameter(url, inputName, value);
		});

		return url;
	}

	// Popup Forms
	let isFormAjaxRunning = false;

	$('body').on( 'submit', '.js-form-login', function(e) {
		e.preventDefault();

		const email 	= $(this).find('input[type="email"]').val();
		const password  = $(this).find('input[type="password"]').val();
		const remember  = $(this).find('input[name="remember"]').is(':checked');

		tryFormLogin( email, password, remember );
	} );

	$('body').on( 'submit', '.js-form-register', function(e) {
		e.preventDefault();

		const firstName 		= $(this).find('input[name="first-name"]').val();
		const lastName 			= $(this).find('input[name="last-name"]').val();
		const email 			= $(this).find('input[name="email"]').val();
		const password 			= $(this).find('input[name="password"]').val();
		const passwordConfirm 	= $(this).find('input[name="password-confirm"]').val();
		const subscribe 		= $(this).find('input[name="subscribe"]').is(':checked');
		const recaptchaSiteKey  = $(this).find('button.form__btn').attr('data-sitekey');

		const userData = {
			firstName,
			lastName,
			email,
			password,
			passwordConfirm,
			subscribe,
			recaptchaSiteKey
		};

		tryFormRegister( userData );
	} );

	function afterSuccessLogin( response ) {
		$.magnificPopup.close();
		$('.hero--primary .hero__content p, .hero--primary .hero__content ul').remove();
	}

	function makeFormAjax( action, data ) {
		$.ajax({
			url: main_theme.ajax_url,
			method: 'POST',
			data,
			success: afterSuccessLogin,
			error: error => {
				$('.js-form-' + action).find('.form__error').show().html( `<p>${error.responseJSON.data}</p>` );
			}
		});
	}

	function tryFormLogin( email, password, isRemember ) {
		makeFormAjax( 'login', {
			action: 'efront_try_login',
			email,
			password,
			isRemember
		} );
	}

	function tryFormRegister( userData ) {
		console.log('sitekey: ' + userData.recaptchaSiteKey);
		grecaptcha.ready(function () {
			grecaptcha.execute(userData.recaptchaSiteKey, { action: 'submit' }).then(function (token) {
				userData.token = token;
				makeFormAjax( 'register', {
					action: 'efront_try_register',
					userData
				});
			});
		});
	}

	$(window).on('load', function() {
		initDropdowns();
	})

	$(document).on('gform_post_render', function (event, form_id, current_page) {
		initDropdowns();
	});
})(jQuery, window, document);